import type { Value } from 'modules/core/components/MultiFilters/hooks/utils/defaultEvaluators'
import { employeeLegalEntityId } from 'modules/core/lib/employeeLegalEntity'
import { getFullDisplayName } from 'modules/core/lib/userDisplayName'
import users from 'modules/core/store/collections/users'

import type Employee from 'modules/employees/store/models/Employee'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'
import { employeeTeams } from 'modules/teams/store/employeeTeams'

export default (employee: Employee, value: Value) => {
  switch (value) {
    case 'employee_status':
    case 'clockin_status':
    case 'alerts':
      return employee

    case 'employee_name': {
      const user = users.get(employee.attributes.access_id)
      if (!user) {
        throw Error(`Error getting users with id = ${employee.attributes.access_id}`)
      }
      return getFullDisplayName({
        firstName: user.attributes.first_name,
        lastName: user.attributes.last_name,
        canSharePreferredName: employee.policy.can('sharePreferredName'),
        preferredName: employee.attributes.preferred_name,
      })
    }

    case 'location':
      return employee.attributes.location_id

    case 'team':
      return employeeTeams(teams, memberships, employee.id).map((team) => team.attributes.id)

    case 'legal_entity':
      return employeeLegalEntityId(employee)
  }
}
